<template>
  <div v-html="content" v-loading="loading"></div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      content: ''
    }
  },
  created() {
    this.loading = true;
    this.$http.get(this.$api.systemApi.bzDetail).then(({ data }) => {
      this.loading = false;
      this.content = data.data.content;
    }).catch(() => {
      this.loading = false;
      this.content = '';
    });
  }
};
</script>

<style lang="scss" scoped></style>
